import type { IAPI } from '../../apiResponse';
import { getRequest, type IRequestOptions } from '../../httpClient';
import {
  getChallengeVsBundleV1ResponseSchema,
  type IChallengeVsBundleV1,
} from './get-challenge-vs-bundle-v1-response';

export async function getChallengeVsBundleV1Api(slugs: string[], options?: IRequestOptions) {
  const query = slugs.map((slug) => encodeURIComponent(slug)).join(',');
  return getRequest<IAPI<IChallengeVsBundleV1>>({
    path: `/challenges/v1/vs-bundle?slugs=${query}`,
    schema: getChallengeVsBundleV1ResponseSchema,
    options,
  });
}
